/**
 * The site's maintenance notice (03 §12.6, AC-ADM-51) on every page: `/api/config` seeds it at load, and the lobby
 * socket keeps it live (`lobbyWelcome.notice`, `notice`; 04 §9.3).
 */
import { getLocale, intlLocale, t } from '@tarock/i18n';
import type { MaintenanceNotice } from '@tarock/protocol';
import { useEffect } from 'preact/hooks';
import { publicConfig } from '../auth/config';
import { lobbyStore } from '../stores/lobby';

/** The notice in my language (else English, else any), with its end if it has one. */
export function noticeText(n: MaintenanceNotice): string {
  const message = n.message[getLocale()] ?? n.message.en ?? Object.values(n.message)[0] ?? '';
  return n.until
    ? `${message} ${t('maintenance.until', { date: new Date(n.until).toLocaleString(intlLocale()) })}`
    : message;
}

/** Shown on every page while a notice is set. */
export function MaintenanceBanner() {
  useEffect(() => {
    void publicConfig().then((c) => {
      // the lobby socket's notice is fresher than the page's config
      if (c && lobbyStore.conn.peek() !== 'open') {
        lobbyStore.notice.value = c.maintenance;
      }
    });
  }, []);
  const n = lobbyStore.notice.value;
  if (!n) {
    return null;
  }
  return (
    <div class="maintenance-banner" role="status" data-testid="maintenance-banner">
      {noticeText(n)}
    </div>
  );
}
